import React from "react"

import getIdealImage from "utils/getIdealImage"

import { isGifImage, gifToMp4Extension, removeNonVideoTransforms, Gif } from "./cloudinary-image"
import { Image } from "./cloudinary-image/styles"

const CroppedImage = ({
  lazy,
  alt,
  role,
  imageData,
  sizes,
  noRetina,
  loading,
  fetchpriority,
  ...props
}) => {
  const imageRole = role || !alt ? "presentation" : ""

  return (
    imageData && (
      <Image lazy={lazy} {...props}>
        {imageData.path && isGifImage(imageData.path) ? (
          <Gif>
            {sizes.map(({ query, width, height, transforms }) => {
              const videoUrl = gifToMp4Extension(
                getIdealImage(
                  imageData,
                  removeNonVideoTransforms(transforms),
                  width,
                  height,
                  false,
                ),
              )

              return (
                <source
                  key={query}
                  media={`(min-width: ${query}px)`}
                  type="video/mp4"
                  src={videoUrl}
                />
              )
            })}
          </Gif>
        ) : (
          <picture>
            {sizes.map(({ query, width, height, transforms }) => {
              const url1x = getIdealImage(imageData, transforms, width, height, false)
              const url2x = getIdealImage(
                imageData,
                transforms.concat("/dpr_2.0"),
                width,
                height,
                false,
              )

              const srcSet = `${url1x}${noRetina ? "" : `, ${url2x} 2x`}`
              const srcProps = { srcSet }

              if (!query) {
                if (lazy) {
                  return (
                    <img
                      key="default"
                      loading="lazy"
                      role={imageRole}
                      fetchpriority="low"
                      alt=""
                      {...(width && { width })}
                      {...(height && height < 1000 && { height })}
                      {...(alt && { alt, title: alt })}
                      src={url1x}
                      {...srcProps}
                    />
                  )
                }
                return (
                  <img
                    key="default"
                    role={imageRole}
                    alt=""
                    {...(fetchpriority && { fetchpriority: fetchpriority })}
                    {...(alt && { alt, title: alt })}
                    {...(loading && { loading })}
                    {...(width && { width })}
                    {...(height && height < 1000 && { height })}
                    src={url1x}
                    {...srcProps}
                  />
                )
              }

              return (
                <source
                  key={query}
                  {...(width && { width })}
                  {...(height && height < 1000 && { height })}
                  media={`(min-width: ${query}px)`}
                  {...srcProps}
                />
              )
            })}
          </picture>
        )}
      </Image>
    )
  )
}

export default CroppedImage
